import React from 'react'

export default function ProfileBanner() {
  return (
    <div>
        <section class="single-banner dashboard-banner">
         <div class="container">
            <div class="row">
               <div class="col-lg-12">
                  <div class="single-content">
                     <h2>profile</h2>
                     <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">profile</li>
                     </ol>
                  </div>
               </div>
            </div>
         </div>
      </section>
    </div>
  )
}
